import { render, staticRenderFns } from "./opinionList.vue?vue&type=template&id=f270919c&"
import script from "./opinionList.vue?vue&type=script&lang=js&"
export * from "./opinionList.vue?vue&type=script&lang=js&"
import style0 from "./opinionList.vue?vue&type=style&index=0&id=f270919c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports